export const HIGHEST_LOWEST_ROLLOVER = "HIGHEST_LOWEST_ROLLOVER";
export const HIGHEST_LOWEST_ROLLOVER_STREAM = "HIGHEST_LOWEST_ROLLOVER_STREAM";
export const ROLLOVER_LAST_UPDATED_TIME = "ROLLOVER_LAST_UPDATED_TIME";
